












































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import { timeout } from '@/utils/common'

@Component
export default class ModalAddGestores extends Vue {
  camposCadastrais: boolean = false

  $refs!: {
    formAddGestores: any,
    imageUpload: any,
  }

  formAddGestoresRules: any = {
    valid: true,
    cpf: [(v: any) => !!v || 'Campo obrigatório'],
    nome: [(v: any) => !!v || 'Campo obrigatório'],
    email: [(v: any) => !!v || 'Campo obrigatório'],
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get showModalAddGestores() { return this.getRecebimentoStore.modalAddGestores }
  set showModalAddGestores(value: boolean) { this.getRecebimentoStore.setModalAddGestores(value) }

  async saveAddGestor() {
    if (this.$refs.formAddGestores.validate()) {
      EventBus.$emit('setLoadingRequest', { status: '', text: 'Verificando CPF...' })
      try {
        // 1. Verificar cpf
        const checkCPFRequest = await this.getRecebimentoStore.checkCpfGestor()

        if (checkCPFRequest.success) {
          EventBus.$emit('setLoadingRequest', { status: '', text: 'CPF encontrado. Incluindo gestor no contrato ...' })
          await timeout(1000)
          // 2. Adicionar gestor, caso cpf exista...
          await this.fluxoDeGestor()
        } else {
          // 2. Adicionar pessoa, caso cpf não exista...
          EventBus.$emit('setLoadingRequest', { status: '', text: 'CPF não encontrado. Iniciando cadastro do gestor ...' })
          await timeout(1000)
          EventBus.$emit('setLoadingRequest', { status: '', text: 'Liberando o usuário ...' })
          await timeout(1000)

          try {
            const requestFluxoSemCPF = await this.getRecebimentoStore.fluxoSemCpf()

            if (requestFluxoSemCPF.success) {
              EventBus.$emit('setLoadingRequest', { status: '', text: 'Usuário liberado ...' })
              await timeout(1000)
              // 3. Com o CPF na base, adicionamos o gestor
              await this.fluxoDeGestor()
            } else {
              EventBus.$emit('clearLoadingRequest')
              EventBus.$emit('setSnackbar', { show: true, text: requestFluxoSemCPF.message, icon: 'warning', color: '#C62828' })
            }
          } catch (error) {
            EventBus.$emit('clearLoadingRequest')
            EventBus.$emit('setSnackbar', {
              show: true,
              text: `${(error as any).message} ${String.fromCodePoint(0x1F615)}`,
              icon: 'warning',
              color: '#C62828',
            })
          }
        }
      } catch (error) {
        EventBus.$emit('clearLoadingRequest')
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `${(error as any).message} ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }
  }

  async fluxoDeGestor() {
    try {
      EventBus.$emit('setLoadingRequest', { status: '', text: 'Adicionando gestor no contrato ...' })
      await timeout(1000)
      const addGestorRequest = await this.getRecebimentoStore.addGestor()

      if (addGestorRequest.success) {
        EventBus.$emit('setLoadingRequest', { status: '', text: 'Gestor adicionado no contrato ...' })
        await timeout(1000)

        // 3. Enviar autenticação
        try {
          EventBus.$emit('setLoadingRequest', { status: '', text: 'Enviando autenticação ...' })
          await timeout(1000)
          const requestEnvioAutenticacao = await this.getRecebimentoStore.envioAutenticacao()
          if (requestEnvioAutenticacao.success) {
            EventBus.$emit('setLoadingRequest', { status: '', text: 'Gestor adicionado com sucesso!' })
            await timeout(1000)
            EventBus.$emit('clearLoadingRequest')
          } else {
            EventBus.$emit('clearLoadingRequest')
            EventBus.$emit('setSnackbar', { show: true, text: requestEnvioAutenticacao.message, icon: 'warning', color: '#C62828' })
          }
        } catch (error) {
          EventBus.$emit('clearLoadingRequest')
          EventBus.$emit('setSnackbar', {
            show: true,
            text: `${(error as any).message} ${String.fromCodePoint(0x1F615)}`,
            icon: 'warning',
            color: '#C62828',
          })
        }
      } else {
        EventBus.$emit('clearLoadingRequest')
        EventBus.$emit('setSnackbar', {
          show: true,
          text: addGestorRequest ? (addGestorRequest as any).errors[0].message : 'Erro ao adicionar gestor',
          icon: 'warning',
          color: '#C62828',
        })
      }
    } catch (error) {
      EventBus.$emit('clearLoadingRequest')
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${(error as any).message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  @Watch('showModalAddGestores')
  onChangeShowModalEditarHospital(value: boolean) {
    if (!value) {
      this.$refs.formAddGestores.resetValidation()
      this.$refs.formAddGestores.reset()
    }
  }
}
